import { requiredBaseRule } from 'utils/constants';
import { replacerCost } from 'utils/replacerCost';

type CoefficientValue = string | number | null | undefined;

export const positiveCoefficientRule = {
    validate: (value: CoefficientValue) => {
        if (value === null || value === undefined || value === '') {
            return requiredBaseRule.required;
        }

        return replacerCost(value) > 0 || 'Значение должно быть больше 0';
    },
};

export const dismantlingMaterialRule = {
    validate: (value: CoefficientValue) =>
        value === null ||
        value === undefined ||
        value === '' ||
        replacerCost(value) >= 0 ||
        'Значение должно быть не меньше 0',
};
